import { useCallback, useEffect, useRef, useState } from 'react';
import { Banner, BlockStack, Button, Card, Text } from '@shopify/polaris';
import { useApi } from '../../hooks/useApi';
type Summary = { total: number; enabled: number; needs_attention: number };
export default function TrackingScheduleOverview() {
  const { fetchApi, loading, error } = useApi(); const [summary, setSummary] = useState<Summary | null>(null);
  const generation = useRef(0);
  const load = useCallback(async () => {
    const version = ++generation.current;
    const result = await fetchApi<{ summary: Summary }>('/api/couriers/tracking-schedules');
    if (generation.current === version) setSummary(result?.summary ?? null);
  }, [fetchApi]);
  useEffect(() => { void load(); return () => { generation.current++; }; }, [load]);
  return <Card><BlockStack gap="200"><Text as="h2" variant="headingMd">Scheduled tracking</Text>
    <Text as="p">Open a booked courier shipment to enable checks every 15, 30 or 60 minutes, view saved reports or pause its schedule. Checks use the original DHL, UPS or FedEx account and keep the last successful report during an outage.</Text>
    {error && <Banner tone="warning">{error}</Banner>}
    {summary && <Text as="p">{summary.enabled} enabled · {summary.total - summary.enabled} paused · {summary.needs_attention} need attention</Text>}
    <Button onClick={load} loading={loading}>Refresh tracking schedules</Button>
  </BlockStack></Card>;
}
